import moment from "moment";

export default {
    mixins: [],
    data: () => ({
        date: 60,
    }),
    computed: {},
    methods: {
        /**
         * It checks if the video is already in the shopping cart
         * @param videoId - The id of the video you want to check if it's in the shopping cart.
         * @returns A boolean value.
         */
        videoIsAddedInShoppingCart(videoId) {
            const shoppingCart = Object.values(this.$store.state.shoppingCart);
            const hasVideoInShoppingCartList = shoppingCart.some(
                (video) =>
                    video.type === 3 && video.VideoId === parseInt(videoId)
            );

            return hasVideoInShoppingCartList;
        },
        applyVideoPriming(videosList, videoAdded) {
            const shoppingCart = Object.values(this.$store.state.shoppingCart);
            // recuperamos el id y la promocion del producto agregado al carrito, solo videos
            let videoIdShoppingCart = shoppingCart
                .filter((video) => video.type === 3)
                .map((video) => {
                    return {
                        videoId: video.VideoId,
                        service: video.VideoDetails.serviceId,
                        promotions: video.Promotions,
                    };
                });

            
            
        },
        async addVideoToShoppingCart(videoSelected, albumUuid) {
            
            videoSelected.AlbumUuid = albumUuid;
            await this.$store.dispatch("addCartByVideo", videoSelected);
        },
    },
};